var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-list",class:_vm.status},[_c('i'),_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){_vm.toggle = !_vm.toggle}}})])}
var staticRenderFns = []

export { render, staticRenderFns }